import GridTable from '../components/grid/GridTable'
import GridResults from '../components/grid/GridResults'
import GridLevels from '../components/grid/GridLevels.js'
import GridMarketSummary from '../components/grid/GridMarketSummary.js'
import { USABLE_SCREEN_SIZE } from '../GlobalConstants.js'
import SimpleFillFooter from '../templates/footer/SimpleFillFooter'
import "./Pages.css"
import GridParams from '../components/grid/GridParams'
import * as con from '../GlobalConstants.js'
import { useEffect, useRef, useState } from 'react'
import LoadingOverlay from '../components/modales/LoadingOverlay';
import { useDispatch } from 'react-redux'
import { fetchGridMarketValues, clearManualOverrides } from '../store/slices/gridSlice.js'
import { RefGridStrategyHook } from '../components/hooks/gridStrategyHooks.js'
import { RefModelParameterHook } from '../components/hooks/ModelParameterHooks.js'
import { RefSPOT } from '../components/hooks/MarketValuesHook.js'

function GridPage() {

  const dispatch    = useDispatch()
  const [loading, setLoading] = useState(false)

  const reference_value = RefGridStrategyHook(con.GRID_REFERENCE_VALUE)
  const grid_term       = RefModelParameterHook(con.GRID_TERM)
  const grid_view       = RefGridStrategyHook(con.GRID_VIEW)
  const user_line       = RefModelParameterHook(con.USER_LINE)
  const reference_spot  = RefSPOT()

  const passiveParamsRef = useRef({})
  passiveParamsRef.current = {
    strategy_speed          : RefModelParameterHook(con.STRATEGY_SPEED),
    can_spot                : RefModelParameterHook(con.CAN_SPOT),
    considered_spot_coverage: RefModelParameterHook(con.CONSIDERED_SPOT_COVERAGE),
    can_fwds                : RefModelParameterHook(con.CAN_FWDS),
    can_options             : RefModelParameterHook(con.CAN_OPTIONS),
    automatic_grid          : RefModelParameterHook(con.AUTOMATIC_GRID),
  }

  // Manual edits belong to one client — drop them when the line changes
  useEffect(() => {
    dispatch(clearManualOverrides())
  }, [user_line, dispatch])

  useEffect(() => {
    const run = async () => {
      if (!reference_value || !user_line) return
      try {
        setLoading(true)
        const p = passiveParamsRef.current
        const payload = {
          [con.USER_LINE]                : user_line,
          [con.GRID_REFERENCE_VALUE]     : reference_value,
          [con.GRID_TERM]                : grid_term,
          "reference_spot"               : reference_spot,
          [con.GRID_VIEW]                : grid_view,
          [con.STRATEGY_SPEED]           : p.strategy_speed,
          [con.CAN_SPOT]                 : p.can_spot,
          [con.CONSIDERED_SPOT_COVERAGE] : p.considered_spot_coverage,
          [con.CAN_FWDS]                 : p.can_fwds,
          [con.CAN_OPTIONS]              : p.can_options,
          [con.AUTOMATIC_GRID]           : p.automatic_grid,
        }
        await dispatch(fetchGridMarketValues({ payload })).unwrap()
      } catch (err) {
        console.error("fetchGridMarketValues failed:", err)
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [user_line, reference_value, grid_term, reference_spot, grid_view, dispatch])

  return (
    <div className="grid-page" style={{ height: USABLE_SCREEN_SIZE + "vh" }}>
      {loading && <LoadingOverlay />}
      <div
        className="grid-two-cols"
        style={{
          display: "grid",
          gridTemplateColumns: "40% 60%",
          alignItems: "flex-start",
          gap: "8px",
          padding: "40px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div className="left-col" style={{ display: "flex", flexDirection: "column", gap: "80px" }}>
          <div style={{ width: "85%", margin: "0 auto" }}>
            <GridMarketSummary />
          </div>
          <div style={{ width: "85%", margin: "0 auto" }}>
            <GridLevels />
          </div>
        </div>
        <div className="right-col" style={{ width: "100%" }}>
          <div><GridParams /></div>
          <br />
          <div style={{ width: "100%" }}><GridTable /></div>
          <div style={{ width: "100%" }}><GridResults /></div>
        </div>
      </div>
      <SimpleFillFooter />
    </div>
  )
}

export default GridPage